import React, { FC } from 'react'
import { Field, FieldProps } from 'formik'
import { Toggle } from '@pandiafi/components'

import FormFieldWrapper from 'components/FormField'

interface UserInfoToggleFieldProps {
  name: string
  label: string
  description?: string
}

export const UserInfoToggleField: FC<UserInfoToggleFieldProps> = ({
  name,
  label,
  description,
}) => (
  <Field name={name}>
    {({ field, meta, form }: FieldProps<boolean>) => (
      <FormFieldWrapper name={name} meta={meta} required>
        <Toggle
          id={name}
          checked={field.value}
          labelPosition="left"
          onChange={(value) => {
            form.setFieldTouched(name, true)
            form.setFieldValue(name, value)
          }}
        >
          {description ? (
            <span className="flex flex-col items-end text-right">
              {label}
              <span className="text-xs text-common-gray-6">{description}</span>
            </span>
          ) : (
            label
          )}
        </Toggle>
      </FormFieldWrapper>
    )}
  </Field>
)
